/**
 * Any new action type should be added to the set of exports below.
 *
 * Please keep this list alphabetized.
 */

export const ACCEPT_MEMBERSHIP_FAILURE = Symbol('ACCEPT_MEMBERSHIP_FAILURE')
export const ACCEPT_MEMBERSHIP_REQUEST = Symbol('ACCEPT_MEMBERSHIP_REQUEST')
export const ACCEPT_MEMBERSHIP_SUCCESS = Symbol('ACCEPT_MEMBERSHIP_SUCCESS')
export const ADD_USER = Symbol('ADD_USER')

export const DELETE_USER_AVATAR_FAILURE = Symbol('DELETE_USER_AVATAR_FAILURE')
export const DELETE_USER_AVATAR_REQUEST = Symbol('DELETE_USER_AVATAR_REQUEST')
export const DELETE_USER_AVATAR_SUCCESS = Symbol('DELETE_USER_AVATAR_SUCCESS')

export const FETCH_ARTBOARD_FAILURE = Symbol('FETCH_ARTBOARD_FAILURE')
export const FETCH_ARTBOARD_REQUEST = Symbol('FETCH_ARTBOARD_REQUEST')
export const FETCH_ARTBOARD_SUCCESS = Symbol('FETCH_ARTBOARD_SUCCESS')
export const FETCH_AVATAR_UPLOAD_URL_FAILURE = Symbol(
  'FETCH_AVATAR_UPLOAD_URL_FAILURE'
)
export const FETCH_AVATAR_UPLOAD_URL_REQUEST = Symbol(
  'FETCH_AVATAR_UPLOAD_URL_REQUEST'
)
export const FETCH_AVATAR_UPLOAD_URL_SUCCESS = Symbol(
  'FETCH_AVATAR_UPLOAD_URL_SUCCESS'
)

export const FETCH_COMMENTS_FOR_ARTBOARD_FAILURE = Symbol(
  'FETCH_COMMENTS_FOR_ARTBOARD_FAILURE'
)
export const FETCH_COMMENTS_FOR_ARTBOARD_REQUEST = Symbol(
  'FETCH_COMMENTS_FOR_ARTBOARD_REQUEST'
)
export const FETCH_COMMENTS_FOR_ARTBOARD_SUCCESS = Symbol(
  'FETCH_COMMENTS_FOR_ARTBOARD_SUCCESS'
)
export const FETCH_JWT_FAILURE = Symbol('FETCH_JWT_FAILURE')
export const FETCH_JWT_REQUEST = Symbol('FETCH_JWT_REQUEST')
export const FETCH_JWT_SUCCESS = Symbol('FETCH_JWT_SUCCESS')
export const FETCH_MEMBERSHIP_SHARES_FAILURE = Symbol(
  'FETCH_MEMBERSHIP_SHARES_FAILURE'
)
export const FETCH_MEMBERSHIP_SHARES_REQUEST = Symbol(
  'FETCH_MEMBERSHIP_SHARES_REQUEST'
)
export const FETCH_MEMBERSHIP_SHARES_SUCCESS = Symbol(
  'FETCH_MEMBERSHIP_SHARES_SUCCESS'
)

export const FETCH_SHARES_FAILURE = Symbol('FETCH_SHARES_FAILURE')
export const FETCH_SHARES_REQUEST = Symbol('FETCH_SHARES_REQUEST')
export const FETCH_SHARES_SUCCESS = Symbol('FETCH_SHARES_SUCCESS')

export const FETCH_SHARE_FAILURE = Symbol('FETCH_SHARE_FAILURE')
export const FETCH_SHARE_REQUEST = Symbol('FETCH_SHARE_REQUEST')
export const FETCH_SHARE_SUCCESS = Symbol('FETCH_SHARE_SUCCESS')

export const FETCH_USER_PROFILE_FAILURE = Symbol('FETCH_USER_PROFILE_FAILRE')
export const FETCH_USER_PROFILE_REQUEST = Symbol('FETCH_USER_PROFILE_REQUEST')
export const FETCH_USER_PROFILE_SUCCESS = Symbol('FETCH_USER_PROFILE_SUCCESS')

export const FORGOT_USER_PASSWORD_FAILURE = Symbol(
  'FORGOT_USER_PASSWORD_FAILURE'
)
export const FORGOT_USER_PASSWORD_REQUEST = Symbol(
  'FORGOT_USER_PASSWORD_REQUEST'
)
export const FORGOT_USER_PASSWORD_SUCCESS = Symbol(
  'FORGOT_USER_PASSWORD_SUCCESS'
)

export const REQUEST_ACCESS_FAILURE = Symbol('REQUEST_ACCESS_FAILURE')
export const REQUEST_ACCESS_REQUEST = Symbol('REQUEST_ACCESS_REQUEST')
export const REQUEST_ACCESS_SUCCESS = Symbol('REQUEST_ACCESS_SUCCESS')

export const REQUEST_MEMBERSHIP_FAILURE = Symbol('REQUEST_MEMBERSHIP_FAILURE')
export const REQUEST_MEMBERSHIP_REQUEST = Symbol('REQUEST_MEMBERSHIP_REQUEST')
export const REQUEST_MEMBERSHIP_SUCCESS = Symbol('REQUEST_MEMBERSHIP_SUCCESS')

export const RESEND_VERIFICATION_EMAIL_FAILURE = Symbol(
  'RESEND_VERIFICATION_EMAIL_FAILURE'
)
export const RESEND_VERIFICATION_EMAIL_REQUEST = Symbol(
  'RESEND_VERIFICATION_EMAIL_REQUEST'
)
export const RESEND_VERIFICATION_EMAIL_SUCCESS = Symbol(
  'RESEND_VERIFICATION_EMAIL_SUCCESS'
)

export const RESET_USER_PASSWORD_FAILURE = Symbol('RESET_USER_PASSWORD_FAILURE')
export const RESET_USER_PASSWORD_REQUEST = Symbol('RESET_USER_PASSWORD_REQUEST')
export const RESET_USER_PASSWORD_SUCCESS = Symbol('RESET_USER_PASSWORD_SUCCESS')

export const UPDATE_LAST_READ_ACTIVITY_FAILURE = Symbol(
  'UPDATE_LAST_READ_ACTIVITY_FAILURE'
)
export const UPDATE_LAST_READ_ACTIVITY_REQUEST =
  'UPDATE_LAST_READ_ACTIVTY_REQUEST'
export const UPDATE_LAST_READ_ACTIVITY_SUCCESS = Symbol(
  'UPDATE_LAST_READ_ACTIVITY_SUCCESS'
)
export const UPDATE_LEGACY_SHARE_SETTINGS_FAILURE = Symbol(
  'UPDATE_LEGACY_SHARE_SETTINGS_FAILURE'
)
export const UPDATE_LEGACY_SHARE_SETTINGS_REQUEST = Symbol(
  'UPDATE_LEGACY_SHARE_SETTINGS_REQUEST'
)
export const UPDATE_LEGACY_SHARE_SETTINGS_SUCCESS = Symbol(
  'UPDATE_LEGACY_SHARE_SETTINGS_SUCCESS'
)
export const UPDATE_NUMBER_OF_UNREAD_COMMENTS_FOR_ARTBOARD = Symbol(
  'UPDATE_NUMBER_OF_UNREAD_COMMENTS_FOR_ARTBOARD'
)
export const UPDATE_SHARE_SETTINGS_FAILURE = Symbol(
  'UPDATE_SHARE_SETTINGS_FAILURE'
)
export const UPDATE_SHARE_SETTINGS_REQUEST = Symbol(
  'UPDATE_SHARE_SETTINGS_REQUEST'
)
export const UPDATE_SHARE_SETTINGS_SUCCESS = Symbol(
  'UPDATE_SHARE_SETTINGS_SUCCESS'
)
export const UPDATE_USER = Symbol('UPDATE_USER')
export const UPDATE_USER_AVATAR = Symbol('UPDATE_AVATAR')

export const UPDATE_USER_PROFILE_FAILURE = Symbol('UPDATE_USER_PROFILE_FAILURE')
export const UPDATE_USER_PROFILE_REQUEST = Symbol(
  'UPDATE_USER_PASSWORD_REQUEST'
)
export const UPDATE_USER_PROFILE_SUCCESS = Symbol('UPDATE_USER_PROFILE_SUCCESS')
export const UPLOAD_USER_AVATAR_FAILURE = Symbol('UPLOAD_USER_AVATAR_FAILURE')
export const UPLOAD_USER_AVATAR_REQUEST = Symbol('UPLOAD_USER_AVATAR_REQUEST')
export const UPLOAD_USER_AVATAR_SUCCESS = Symbol('UPLOAD_USER_AVATAR_SUCCESS')
export const WEBSOCKET_CONNECTION_OPEN = Symbol('WEBSOCKET_CONNECTION_OPEN')
export const WEBSOCKET_CONNECTION_CLOSED = Symbol('WEBSOCKET_CONNECTION_CLOSED')
